<div class="ng-bento">
	<bento-alert [items]="alerts"
	(close)="closeAlert($event)">
	</bento-alert>

	<button class="btn btn-outline-primary"
	(click)="addAlert()">
		Add Persistent Alert
	</button>
</div>
